import axios from '@/resources/libs/axios'

export default {
	search(data) {
		return axios.get(`/gei/master-installation/list`, { params: data })
	},
	find(id, data) {
		return axios.get(`/gei/master-installation/find/${id}`, {params: data})
	},
	getMasterInstallationsList(data) {
		return axios.get(`/gei/master-installation/getAllList`, {params: data})
	},
	create(data) {
		return axios.post(`/gei/master-installation/create`,  data)
	},
	update(data) {
		return axios.post(`/gei/master-installation/update`,  data)
	},
	delete(id) {
		return axios.delete(`/gei/master-installation/delete/${id}`)
	},
}